import { storeManager } from './storeManager.js';

export const getStore = () =>
  storeManager.store;